import type { ComponentType } from 'react';
import { UnpaidLayerLiquidCoolingArticle } from '@/components/article_mockup_aug8_2026';
import { NuclearFuelCycleFirmPowerArticle } from '@/components/article_nuclear_fuel_cycle_aug7_2026';

const RESEARCH_ARTICLE_VIEWS: Record<string, ComponentType> = {
  'unpaid-layer-liquid-cooling-thermal-trio': UnpaidLayerLiquidCoolingArticle,
  'Nuclear-Fuel-Cycle-Firm-Power': NuclearFuelCycleFirmPowerArticle,
  'nuclear-fuel-cycle-firm-power': NuclearFuelCycleFirmPowerArticle,
};

const SUBSTACK_STYLE_ARTICLE_IDS = new Set([
  'Nuclear-Fuel-Cycle-Firm-Power',
  'nuclear-fuel-cycle-firm-power',
]);

export function isSubstackStyleArticle(articleId?: string): boolean {
  if (!articleId) return false;
  return SUBSTACK_STYLE_ARTICLE_IDS.has(articleId);
}

export function getResearchArticleView(articleId?: string): ComponentType | null {
  if (!articleId) return null;
  return RESEARCH_ARTICLE_VIEWS[articleId] ?? null;
}
